import type { EmployerInfoValues } from './employerInfoSchema';

export const EMPLOYER_TYPE_OPTIONS = [
  { label: 'Hospital', value: 'Hospital' },
  { label: 'Health System', value: 'Health System' },
  { label: 'Private Practice Group', value: 'Private Practice Group' },
  { label: 'Academic Medical Center', value: 'Academic Medical Center' },
  { label: 'Telehealth Company', value: 'Telehealth Company' },
  { label: 'Urgent Care/Retail Clinic', value: 'Urgent Care/Retail Clinic' },
  { label: 'Diagnostic/Imaging Center', value: 'Diagnostic/Imaging Center' },
  { label: 'Ambulatory Surgery Center', value: 'Ambulatory Surgery Center' },
  { label: 'Specialty Hospital', value: 'Specialty Hospital' },
  { label: 'Long-Term Care Facility', value: 'Long-Term Care Facility' },
  { label: 'Rehabilitation Center', value: 'Rehabilitation Center' },
  { label: 'Home Health Agency', value: 'Home Health Agency' },
  { label: 'Hospice Care', value: 'Hospice Care' },
  { label: 'Dialysis Center', value: 'Dialysis Center' },
  {
    label: 'Mental Health/Behavioral Health Center',
    value: 'Mental Health/Behavioral Health Center',
  },
  { label: 'Substance Abuse Treatment Center', value: 'Substance Abuse Treatment Center' },
  { label: 'Community Health Center', value: 'Community Health Center' },
  { label: 'Critical Access Hospital', value: 'Critical Access Hospital' },
  { label: 'Staffing Agency', value: 'Staffing Agency' },
  {
    label: 'Management Services Organization (MSO)',
    value: 'Management Services Organization (MSO)',
  },
  { label: 'Other', value: 'Other' },
];

export const EMPLOYER_OWNERSHIP_STRUCTURE_OPTIONS = [
  { label: 'For-Profit', value: 'For-Profit' },
  { label: 'Non-Profit', value: 'Non-Profit' },
  { label: 'Government/Public', value: 'Government/Public' },
  { label: 'Academic Medical Center', value: 'Academic Medical Center' },
  { label: 'Private Equity-Backed', value: 'Private Equity-Backed' },
  { label: 'Physician-Owned', value: 'Physician-Owned' },
  { label: 'Joint Venture', value: 'Joint Venture' },
  { label: 'Management Company-Operated', value: 'Management Company-Operated' },
  { label: 'Cooperative/Mutual', value: 'Cooperative/Mutual' },
  { label: 'Public-Private Partnership', value: 'Public-Private Partnership' },
];

export const emptyEmployerRegistrationForm: EmployerInfoValues = {
  legalEntityName: '',
  employerEin: '',
  employerNpi: '',
  employerType: { label: '', value: '' },
  ownershipStructure: { label: '', value: '' },
  employerWebsite: '',
};
